import { init, initFailed, setAllData } from '@store/studyProgrammesApi/studyProgrammesApiState';
import { call, put, takeLatest } from 'redux-saga/effects';
import { loadStudyProgrammes } from './studyProgrammeDataAccess';

function* doInit() {
  try {
    const result = yield call(loadStudyProgrammes);
    yield put(setAllData(result));
  } catch (ex) {
    yield put(initFailed(ex.message));
  }
}

export function* watchInitStudyProgrammeSaga() {
  yield takeLatest(init, doInit);
}
